
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PoPurOrderAppDialog extends Serenity.EntityDialog<PoPurOrderAppRow, any> {
        protected getFormKey() { return PoPurOrderAppForm.formKey; }
        protected getIdProperty() { return PoPurOrderAppRow.idProperty; }
        protected getLocalTextPrefix() { return PoPurOrderAppRow.localTextPrefix; }
        protected getNameProperty() { return PoPurOrderAppRow.nameProperty; }
        protected getService() { return PoPurOrderAppService.baseUrl; }
        protected getDeletePermission() { return PoPurOrderAppRow.deletePermission; }
        protected getInsertPermission() { return PoPurOrderAppRow.insertPermission; }
        protected getUpdatePermission() { return PoPurOrderAppRow.updatePermission; }

        public hide: number;

        protected form = new PoPurOrderAppForm(this.idPrefix);

        constructor() {
            super();
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");


            });

            (this.form.AppList.view as any).onDataChanged.subscribe(() => {
                this.form.AppList.appfg = true;



            });

        }



        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            // if (this.isEditMode()) {



            let Approve: Serenity.ToolButton =
            {
                title: "Confirm",
                hint: "อนุมัติ",
                separator: false,
                cssClass: "bt-approve",
                // icon: "fa fa-save",
                // hotkey: 'alt+x',
                onClick: (e) => {
                    Q.confirm('ยืนยันบันทึก', () => {

                        // this.form.AppList.Appfg = 1;
                        var options = this.getSaveOptions((respons2) => {

                            if (this.isEditMode()) {
                                var id1 = respons2.EntityId;
                                if (id1 == null) {
                                    id1 = this.get_entityId();
                                }
                                this.loadById(id1);
                            }
                            else {
                                this.loadById(respons2.EntityId);
                                // this.dialogClose();
                            }

                            this.showSaveSuccessMessage(respons2);


                        });



                        options.onError = function (respons2) {
                            Q.alert(respons2.Error.Message);
                        }

                        Q.serviceCall(options);




                    });



                }
            };
            buttons.push(Approve);

            let Editaddress: Serenity.ToolButton =
            {
                title: "Hide/Show address'",
                hint: "Edit address",
                separator: false,
                cssClass: "bt-editaddress",
                // icon: "fa fa-save",
                // hotkey: 'alt+x',
                onClick: (e) => {
                    if (this.hide == 1) {
                        this.hideadd(0);
                    } else {
                        this.hideadd(1);
                    }

                }
            };
            buttons.push(Editaddress);

            //     let reject: Serenity.ToolButton =
            //     {
            //         title: "Reject'",
            //         hint: "Reject",
            //         separator: false,
            //         cssClass: "bt-reject",
            //         // icon: "fa fa-save",
            //         // hotkey: 'alt+x',
            //         onClick: (e) => {
            //             Q.confirm('Reject เอกสารนี้', () => {

            //                 // this.form.AppList.Appfg = 2;
            //                 this.save((response) => {
            //                     this.dialogClose();
            //                 });

            //             });
            //         }
            //     };
            //     buttons.push(reject);
            //     let Return: Serenity.ToolButton =
            //     {
            //         title: "กลับไปแก้ไข'",
            //         hint: "Return",
            //         separator: false,
            //         cssClass: "bt-Return",
            //         // icon: "fa fa-save",
            //         // hotkey: 'alt+x',
            //         onClick: (e) => {
            //             Q.confirm('Return เอกสารนี้', () => {

            //                 // this.form.AppList.Appfg = 3;
            //                 this.save((response) => {
            //                     this.dialogClose();
            //                 });

            //             });
            //         }
            //     };
            //     buttons.push(Return);
            // }

            //     buttons.push(
            //         {
            //             title: Q.text("Close"),	// *** Get button text from translation
            //             cssClass: '.panel-titlebar-close',
            //             icon: 'fa-close',
            //             hint: 'esc',
            //             hotkey: 'esc',
            //             onClick: () => {
            //                 this.dialogClose();

            //             },
            //         }
            //     );




            return buttons;


        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.syscuscheck();

            // this.form.DtList.myPassValue = this.form.SysDocNo.value
            // this.form.DtList.supid = this.form.SupplierId.value
            // this.form.DtList.whsid = this.form.WhsId.value
            this.hideadd(1);



            //  let textcomfrim = "เมื่ออนุมัติโปรด Confirm การอนุมัติที่หัวเอกสาร"
            //  textcomfrim.insertAfter(this.form.DiscText.element)
            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();
            if (this.entity.SendForAppfg == 0) {
                this.toolbar.findButton('bt-approve').hide();
            }



        }

        protected getSaveEntity(): PoPurOrderAppRow {
            let entity = super.getSaveEntity();

            return entity;
        }

        private syscuscheck() {

            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 3 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.form.SalesVatTypes.getGridField().toggle(true);
            } else {
                this.form.SalesVatTypes.getGridField().toggle(false);
            }

            let vatfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 64 && x.SysFg > 0)
            console.log(vatfg)
            if (vatfg != null) {
                this.form.VatFg.getGridField().toggle(true);
            } else {
                this.form.VatFg.getGridField().toggle(false);
            }

            let potype = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 68 && x.SysFg > 0)

            if (potype != null) {
                // this.potypefg = 1;
                this.form.POTypeFg.getGridField().toggle(true);
            } else {
                // this.potypefg = 0;
                this.form.POTypeFg.getGridField().toggle(false);
            }



        }



        private hideadd(hided: number) {
            if (hided == 1) {
                this.form.ShipLineAddress1.getGridField().toggle(false);
                this.form.ShipLineAddress2.getGridField().toggle(false);
                this.form.ShipLineAddress3.getGridField().toggle(false);
                this.hide = 1
            } else {
                this.form.ShipLineAddress1.getGridField().toggle(true);
                this.form.ShipLineAddress2.getGridField().toggle(true);
                this.form.ShipLineAddress3.getGridField().toggle(true);
                this.hide = 0
            }
        }



    }
}